/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Vue} from 'vue-property-decorator';

/**
 * File count validation rule.
 * Creates a custom file count validation rule.
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

export const FileCountValidator: object = {
    /**
     * Message response.
     * @param {string} field
     * @param args
     * @return {string}
     */
    getMessage(field: any, args: number[]|null): string {
        return Vue.i18n.translate('validator.file-count.error',
            {count: !!args ? args[0] : ''}) ||
            'You have selected too many files';
    },

    /**
     * Validate the file count.
     * @param {File | File[] | undefined | null} value
     * @param {number} count
     * @return {boolean}
     */
    validate(value: File|File[]|undefined|null, {count}: {count: number}): boolean {
        if (undefined === value || null === value) {
            return false;
        }

        const files: File[] = (value instanceof File) ? [value] : value;

        return files.length <= count;
    },
};
